export class ValidationPatterns {
  public static readonly SIUnit: string =
    "^[A-Za-z0-9./⁰¹²³⁴⁵⁶⁷⁸⁹₀₁₂₃₄₅₆₇₈₉]+$";
  public static readonly NameWithoutNos: string = "^[a-zA-Z\\s]+$";
  public static readonly NameWithNos: string = "^[a-zA-Z0-9]+$";
  public static readonly NameWithoutNoswith_: string = "^[a-zA-Z\\s_]+$";
  public static readonly Email: string =
    "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov|co\.in|info)$";
  public static readonly INDPhoneNo: string = "^[6789][0-9]{9}$";
  public static readonly Address: string = "^[a-zA-Z0-9 ,./#-]{5,100}$";

  public static readonly NameWithNosAndSpace: string = "^[a-zA-Z0-9\\s]+$";
  public static readonly NameWithNosAndSpaceAnd_: string = "^[a-zA-Z0-9\\s_]+$";

  public static readonly CurrencyRegex: string =
    "^[A-Za-z\\s$€£¥₹₩₽₦₪฿₫₴₲₵₣₱₲]+$";
  public static readonly CurrencySymbolRegex: string =
    "^[\\$€£¥₹₩₽₦₪฿₫₴₲₵₣₱؋]+|^[A-Za-z]{1,10}$";
  public static readonly CurrencyNameRegex: string = "^[A-Za-z\\s-]{1,30}$";
  public static readonly InputNumber: string = "^[0-9]{1,3}$";
  public static readonly LargeInputNumber: string = "^[0-9]{1,18}$";
  public static readonly PinCode: string = "^[0-9]{6}$";
  public static readonly Website: string = "https?://.+";
  public static readonly IFSC: string = "[A-Z]{4}0[A-Z0-9]{6}";
  public static readonly AbhaNo: string = "^[0-9]{14}$";
  public static readonly PAN: string = "[A-Z]{5}[0-9]{4}[A-Z]";
  public static readonly AadharNo: string = "^[2-9]{1}[0-9]{11}$";
  public static readonly GSTIN: string =
    "[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]";
  public static readonly CIN: string =
    "^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$";
  public static readonly AgeLimit: string = "/^\d{2}-\d{2}$/";
  public static readonly demo: string = "demo";
}

export class ValidationMessages {
  public static readonly RequiredFieldMsg: string = "This field is required!";
  public static readonly SIUnitMsg: string =
    "Special char, _ , space not allowed";
  public static readonly NameWithoutNosMsg: string =
    "Special char, _ ,Number not allowed";
  public static readonly NameWithNosMsg: string =
    "Special char, _ and space not allowed";
  public static readonly NameWithoutNoswith_Msg: string =
    "Special char,Number not allowed";
  public static readonly NameWithNosAndSpaceMsg: string =
    "Special char & _ not allowed";
  public static readonly NameWithNosAndSpaceAnd_Msg: string =
    "Special char not allowed";

  public static readonly EmailMsg: string =
    "Please Enter a Valid Email Address.";
  public static readonly INDPhoneNoMsg: string =
    "Please Enter a Valid 10-digit Mobile Number starting with 6, 7, 8, or 9.";
  public static readonly InputNumberMsg: string =
    "Please enter a number between 0 and 999.";
  public static readonly LargeInputNumberMsg: string =
    "Please enter a number between 9 to 18 Digit.";
  public static readonly IPAddressMsg: string =
    "Please enter a valid IPv4 address (e.g., 192.168.1.1).";
  public static readonly ONVIFPortMsg: string =
    "Please enter a valid port number between 0 and 65535.";

  public static readonly PinCodeMsg: string =
    "Please enter a valid 6-digit PIN code (starting with a number between 1 and 9).";

  public static readonly WebsiteMsg: string =
    "Please enter a valid URL starting with 'http://' or 'https://'.";

  public static readonly CurrencyRegexMsg: string =
    "Please enter a valid currency name or symbol. Only letters, spaces, and currency symbols are allowed";
  public static readonly CurrencySymbolRegexMsg: string =
    "Please enter a valid currency symbol or currency code (up to 10 letters)";
  public static readonly CurrencyNameRegexMsg: string =
    "Please enter a valid name (letters, spaces, and hyphens only, up to 30 characters)";

  public static readonly UrlMsg: string =
    "Please enter a valid URL starting with 'http' or 'https'.";
  public static readonly GoogleLocationMsg: string =
    "Please enter a valid URL starting with 'http://', 'https://', or exactly 'www.google'.";
  public static readonly AddressMsg: string =
    "Please enter a valid address (letters, numbers, spaces, and common symbols such as comma, period, hyphen, slash, and hash).";

  public static readonly AbhaNoMsg: string = "Invalid Abha No.!";
  public static readonly IFSCMsg: string = "Invalid IFSC Code!";
  public static readonly PANMsg: string = "Invalid PAN!";
  public static readonly AadharNoMsg: string = "Invalid Aadhar No.!";
  public static readonly GSTINMsg: string = "Invalid GSTIN!";
  public static readonly CINMsg: string = "Invalid CIN!";
  public static readonly AgeLimitMsg: string = "Invalid Age Limit!";
}

export class CountryStateCityRefs {
  public static readonly IndiaRef = 800051;
  public static readonly MaharashtraRef = 800051;
  public static readonly KolhapurRef = 800051;
}

export class ZoneDistrictRefs {
  public static readonly ZoneRef = 1000000000047377;
  public static readonly DistrictRef = 1000000000000950;
  public static readonly StateRef = 1000000000000484;
}

export class AddressStateRefs {
  public static readonly HimachalPradesh: number = 800053;
  public static readonly JammuKashmir: number = 800052;
  public static readonly Punjab: number = 800054;
  public static readonly Chandigarh: number = 800055;
  public static readonly Uttarakhand: number = 800056;
  public static readonly Haryana: number = 800057;
  public static readonly Delhi: number = 800058;
  public static readonly Rajastan: number = 800059;
  public static readonly UttarPradesh: number = 800060;
  public static readonly Bihar: number = 800061;
  public static readonly Sikkim: number = 800062;
  public static readonly ArunachalPradesh: number = 800063;
  public static readonly Nagaland: number = 800064;
  public static readonly Manipur: number = 800065;
  public static readonly Mizoram: number = 800066;
  public static readonly Tripura: number = 800067;
  public static readonly Meghalaya: number = 800068;
  public static readonly Assam: number = 800069;
  public static readonly WestBengal: number = 800070;
  public static readonly Jharkhand: number = 800071;
  public static readonly Orrisa: number = 800072;
  public static readonly Chhattisgarh: number = 800073;
  public static readonly MadhyaPradesh: number = 800074;
  public static readonly Gujarat: number = 800075;
  public static readonly DamanAndDiu: number = 800076;
  public static readonly DadarAndNagarHaveli: number = 800077;
  public static readonly Maharashtra: number = 800078;
  public static readonly Karnataka: number = 800079;
  public static readonly Goa: number = 800080;
  public static readonly Lakshdweep: number = 800081;
  public static readonly Kerala: number = 800082;
  public static readonly TamilNadu: number = 800083;
  public static readonly Puducherry: number = 800084;
  public static readonly AndmanAndNicobar: number = 800085;
  public static readonly Telangana: number = 800086;
  public static readonly AndhraPradesh: number = 800087;
  public static readonly OtherTerritory: number = 800088;
  public static readonly OtherCountry: number = 800089;
}

export enum FEATURE {
  DASHBOARD = "DASHBOARD",
  HR = "HR",
  TRAINING = "TRAINING",
  PERFORMANCE = "PERFORMANCE",
  CHILD = "CHILD",
  STOCK = "STOCK",
  FAMILY_PLANNING = "FAMILY PLANNING",
  OTHER = "OTHER",
}

export enum FEATURE_GROUP {
  MASTER = "MASTER",
  TRANSACTION = "TRANSACTION",
  REPORT = "REPORT",
}

export enum SUBMENU_ID {
  // STATE_MASTER = FEATURE_GROUP.MASTER+'/'+'State_Master',
  // Dashboard
  TOTAL_ASHA_TRAINED = "Total_Asha_Trained",

  STATE_MASTER = "State_Master",
  ZONE_MASTER = "Zone_Master",
  DISTRICT_MASTER = "District_Master",
  BLOCK_MASTER = "Block_Master",
  PHC_MASTER = "PHC_Master",
  SC_MASTER = "SC_Master",
  VILLAGE_MASTER = "Village_Master",
  DHO_POST_MASTER = "Dho_Post_Master",
  DHO_POST_MASTER_DETAILS = "Dho_Post_Master_Details",

  DCM_POST_MASTER = "Dcm_Post_Master",
  DCM_POST_MASTER_DETAILS = "Dcm_Post_Master_Details",

  BCM_POST_MASTER = "Bcm_Post_Master",
  BCM_POST_MASTER_DETAILS = "Bcm_Post_Master_Details",

  AF_POST_MASTER = "Af_Post_Master",
  AF_POST_MASTER_DETAILS = "Af_Post_Master_Details",

  ASHA_POST_MASTER = "Asha_Post_Master",

  ASHA_MASTER = "Asha_Master",
  ASHA_MASTER_DETAILS = "Asha_Master_Details",

  AF_MASTER = "AF_Master",
  AF_MASTER_DETAILS = "AF_Master_Details",

  DHO_MASTER = "DHO_Master",
  DHO_MASTER_DETAILS = "DHO_Master_Details",

  THO_MASTER = "THO_Master",
  THO_MASTER_DETAILS = "THO_Master_Details",

  DCM_MASTER = "DCM_Master",
  DCM_MASTER_DETAILS = "DCM_Master_Details",

  BCM_MASTER = "BCM_Master",
  BCM_MASTER_DETAILS = "BCM_Master_Details",

  MO_MASTER = "MO_Master",
  MO_MASTER_DETAILS = "MO_Master_Details",

  CATEGORY_MASTER = "Category_Master",
  VIMA_YOJANA_MASTER = "Vima_Yojana_Master",
  ROLES_MASTER = "Roles_Master",
  RELATION_MASTER = "Relation_Master",
  BIRTH_DEFECT_TYPE_MASTER = "Birth_Defect_Type_Master",

  TRAINING_GROUP_MASTER = "Training_Group_Master",
  TRAINING_TYPE_MASTER = "Training_Type_Master",

  GRIEVANCE_GROUP_MASTER = "Grievance_Group_Master",
  GRIEVANCE_TYPE_MASTER = "Grievance_Type_Master",

  PERFORMANCE_GROUP_MASTER = "Performance_Group_Master",
  PERFORMANCE_TYPE_MASTER = "Performance_Type_Master",
  ACTIVITY_RATE_MASTER = "Activity_Rate_Master",

  HBNC_GROUP_MASTER = "Hbnc_Group_Master",
  HBNC_KIT_GROUP = "Hbnc_Kit_Group",
  HBNC_TYPE_MASTER = "Hbnc_Type_Master",

  HBYC_GROUP_MASTER = "Hbyc_Group_Master",
  HBYC_TYPE_MASTER = "Hbyc_Type_Master",
  HBYC_UNTRAINED_GROUP_MASTER = "Hbyc_Untrained_Group_Master",
  HBYC_UNTRAINED_TYPE_MASTER = "Hbyc_Untrained_Type_Master",

  AF_CENTRAL_INCENTIVE_MASTER = "AF_Central_Incentive",
  AF_STATE_INCENTIVE_MASTER = "AF_State_Incentive_Master",

  CENTRAL_INCENTIVE_GROUP_MASTER = "Central_Incentive_Group_Master",
  CENTRAL_INCENTIVE_TYPE_MASTER = "Central_Incentive_Type_Master",

  STATE_INCENTIVE_GROUP_MASTER = "State_Incentive_Group_Master",
  STATE_INCENTIVE_TYPE_MASTER = "State_Incentive_Type_Master",

  RAJYASHASAN_MANDHAN_MASTER = "Rajyashasan_Mandhan_Master",

  PROMOTION_MASTER = "Promotion_Master",
  PROMOTION_MASTER_DETAILS = "Promotion_Master_Details",

  TERMINATION_MASTER = "Termination_Master",
  TERMINATION_MASTER_DETAILS = "Termination_Master_Details",

  RESIGNATION_MASTER = "Resignation_Master",
  RESIGNATION_MASTER_DETAILS = "Resignation_Master_Details",

  MOTHER_MEETING_GROUP_MASTER = "Mother_Meeting_Group_Master",
  MOTHER_MEETING_GROUP_MASTER_DETAILS = "Mother_Meeting_Group_Master_Details",

  MOTHER_MEETING_TYPE_MASTER = "Mother_Meeting_Type_Master",
  MOTHER_MEETING_TYPE_MASTER_DETAILS = "Mother_Meeting_Type_Master_Details",

  SPACING_OF_BIRTH_GROUP_MASTER = "Spacing_Of_Birth_Group_Master",
  SPACING_OF_BIRTH_GROUP_MASTER_DETAILS = "Spacing_Of_Birth_Group_Master_Details",

  SPACING_OF_BIRTH_TYPE_MASTER = "Spacing_Of_Birth_Type_Master",
  SPACING_OF_BIRTH_TYPE_MASTER_DETAILS = "Spacing_Of_Birth_Type_Master_Details",

  IODINE_TESTING_GROUP_MASTER = "Iodine_Testing_Group_Master",
  IODINE_TESTING_GROUP_MASTER_DETAILS = "Iodine_Testing_Group_Master_Details",
  IODINE_TESTING_TYPE_MASTER = "Iodine_Testing_Type_Master",
  IODINE_TESTING_TYPE_MASTER_DETAILS = "Iodine_Testing_Type_Master_Details",

  SANITARY_NAPKIN_RATE_MASTER = "Sanitary_Napkin_Rate_Master",
  SANITARY_NAPKIN_RATE_MASTER_DETAILS = "Sanitary_Napkin_Rate_Master_Details",

  VISIT_TYPE_MASTER = "Visit_Type_Master",
  VISIT_TYPE_MASTER_DETAILS = "Visit_Type_Master_Details",

  REPORT_CONFIGURATION_MASTER = "Report_Configuration_Master",
  REPORT_CONFIGURATION_MASTER_DETAILS = "Report_Configuration_Master_Details",

  ABOUT_MASTER = "About_Master",
  ABOUT_MASTER_DETAILS = "About_Master_Details",

  WORK_GALLERY_MASTER = "Work_Gallery_Master",
  WORK_GALLERY_MASTER_DETAILS = "Work_Gallery_Master_Details",

  TRAINING_VIDEO_MASTER = "Training_Video_Master",
  TRAINING_VIDEO_MASTER_DETAILS = "Training_Video_Master_Details",

  HEALTH_DEPARTMENT_PROFILE_MASTER = "Health_Department_Profile_Master",
  HEALTH_DEPARTMENT_PROFILE_MASTER_DETAILS = "Health_Department_Profile_Master_Details",

  RELIGION_MASTER = "Religion_Master",
  RELIGION_MASTER_DETAILS = "Religion_Master_Details",

  TEST_COMPONENT = "Test_Component",

  // ================= TRANSACTIONS =================
  ASHA_TRAINING_FORM = "Asha_Training_Form",
  ASHA_TRAINING_FORM_DETAILS = "Asha_Training_Form_Details",

  ASHA_HR_TRANSACTION = "Asha_Hr_Transaction",
  ASHA_HR_TRANSACTION_DETAILS = "Asha_Hr_Transaction_Details",

  ASHA_TRAINING_REPORT = "Asha_Training_Report",
  ASHA_TRAINING_REPORT_DETAILS = "Asha_Training_Report_Details",

  AF_TRAINING_REPORT = "AF_Training_Report",
  AF_TRAINING_REPORT_DETAILS = "AF_Training_Report_Details",

  EDIT_REQUEST_FORM = "Edit_Request_Form",
  EDIT_REQUEST_FORM_DETAILS = "Edit_Request_Form_Details",

  EDIT_REQUEST_APPROVAL_FORM = "Edit_Request_Approval_Form",
  EDIT_REQUEST_APPROVAL_FORM_DETAILS = "Edit_Request_Approval_Form_Details",

  AF_CENTRAL_INCENTIVE_TRANSACTION = "AF_Central_Incentive_Transaction",
  AF_CENTRAL_INCENTIVE_TRANSACTION_DETAILS = "AF_Central_Incentive_Transaction_Details",

  STATE_INCENTIVE = "State_Incentive",
  STATE_INCENTIVE_DETAILS = "State_Incentive_Details",

  STATE_INCENTIVE_TRANSACTION = "State_Incentive_Transaction",
  STATE_INCENTIVE_TRANSACTION_DETAILS = "State_Incentive_Transaction_Details",

  ASHA_PERFORMANCE_FORM = "Asha_Performance_Form",
  ASHA_PERFORMANCE_FORM_DETAILS = "Asha_Performance_Form_Details",

  CENTRAL_INCENTIVE = "Central_Incentive",
  CENTRAL_INCENTIVE_DETAILS = "Central_Incentive_Details",

  MONTHLY_HBNC_TRANSACTION = "Monthly_HBNC_Transaction",
  MONTHLY_HBNC_TRANSACTION_DETAILS = "Monthly_HBNC_Transaction_Details",

  MONTHLY_HBNC_REPORT_DETAILS = "Monthly_HBNC_Report_Details",

  AF_HBNC_TRANSACTION = "Af_HBNC_Transaction",
  AF_HBNC_TRANSACTION_DETAILS = "Af_HBNC_Transaction_Details",

  MONTHLY_HBYC_TRANSACTION = "Monthly_HBYC_Transaction",
  MONTHLY_HBYC_TRANSACTION_DETAILS = "Monthly_HBYC_Transaction_Details",

  MONTHLY_HBYC_REPORT = "Monthly_HBYC_Report",
  MONTHLY_HBYC_REPORT_DETAILS = "Monthly_HBYC_Report_Details",

  HBYC_UNTRAINED_ASHA_REPORT = "HBYC_Untrained_Asha_Report",
  HBYC_UNTRAINED_ASHA_REPORT_DETAILS = "HBYC_Untrained_Asha_Report_Details",

  GRIEVANCE_MONITORING_TRANSACTION = "Grievance_Monitoring_Transaction",
  GRIEVANCE_MONITORING_TRANSACTION_DETAILS = "Grievance_Monitoring_Transaction_Details",

  EMPLOYEE_STATE_INCENTIVE_TRANSACTION = "Employee_State_Incentive_Transaction",
  EMPLOYEE_STATE_INCENTIVE_TRANSACTION_DETAILS = "Employee_State_Incentive_Transaction_Details",

  DEVELOPMENTAL_DELAY_CHILDREN = "Developmental_Delay_Children",
  DEVELOPMENTAL_DELAY_CHILDREN_DETAILS = "Developmental_Delay_Children_Details",

  RBSK_TRANSACTION = "RBSK_Transaction",
  RBSK_TRANSACTION_DETAILS = "RBSK_Transaction_Details",

  DEFECTIVE_CHILDREN = "Defective_Children",
  DEFECTIVE_CHILDREN_DETAILS = "Defective_Children_Details",

  MAA_MEETING = "MAA_Meeting",
  MAA_MEETING_DETAILS = "MAA_Meeting_Details",

  IODINE_TESTING_TRANSACTION = "Iodine_Testing_Transaction",
  IODINE_TESTING_TRANSACTION_DETAILS = "Iodine_Testing_Transaction_Details",

  SPACING_OF_BIRTH = "Spacing_of_Birth",
  SPACING_OF_BIRTH_DETAILS = "Spacing_of_Birth_Details",

  CONTRACEPTIVE_PILLS_OPENING_STOCK_MASTER = "Contraceptive_Pills_Opening_Stock_Master",
  CONTRACEPTIVE_PILLS_OPENING_STOCK_MASTER_DETAILS = "Contraceptive_Pills_Opening_Stock_Master_Details",

  TRANS_CONTRACEPTIVE_PILL = "Trans_Contraceptive_Pill",
  TRANS_CONTRACEPTIVE_PILL_DETAILS = "Trans_Contraceptive_Pill_Details",

  HBNC_KIT_TRANSACTION = "HBNC_Kit_Transaction",
  HBNC_KIT_TRANSACTION_DETAILS = "HBNC_Kit_Transaction_Details",

  SANITARY_NAPKIN_OPENING_STOCK = "Sanitary_Napkin_Opening_Stock",
  SANITARY_NAPKIN_OPENING_STOCK_DETAILS = "Sanitary_Napkin_Opening_Stock_Details",

  SANITARY_NAPKIN_DISTRIBUTION = "Sanitary_Napkin_Distribution",
  SANITARY_NAPKIN_DISTRIBUTION_DETAILS = "Sanitary_Napkin_Distribution_Details",

  VISIT_FORM = "Visit_Form",
  VISIT_FORM_DETAILS = "Visit_Form_Details",

  ANEMIA_MUKTA_BHARAT_OPENING_STOCK_MASTER = "Anemia_Mukta_Bharat_Opening_Stock_Master",
  ANEMIA_MUKTA_BHARAT_OPENING_STOCK_MASTER_DETAILS = "Anemia_Mukta_Bharat_Opening_Stock_Master_Details",

  ANEMIA_MUKTA_BHARAT_DISTRIBUTION = "Anemia_Mukta_Bharat_Distribution",
  ANEMIA_MUKTA_BHARAT_DISTRIBUTION_DETAILS = "Anemia_Mukta_Bharat_Distribution_Details",

  FAMILY_REGISTRATION = "Family_Registration",
  FAMILY_REGISTRATION_DETAILS = "Family_Registration_Details",
  FAMILY_MEMBER = "Family_Member",
  CHANGE_HEAD_OF_FAMILY = "Change_Head_Of_Family",
  SPLIT_FAMILY_DETAILS = "Split_Family_Details",

  Eligible_Couple = "Eligible_Couple",
  Eligible_Couple_DETAILS = "Eligible_Couple_Details",

  HBNC_REGISTER = "HBNC_Register",
  HBNC_REGISTER_DETAILS = "HBNC_Register_Details",

  HBYC_REGISTER = "HBYC_Register",
  HBYC_REGISTER_DETAILS = "HBYC_Register_Details",

    NCD_CBAC_REGISTER = "NCD_CBAC_Register",
  NCD_CBAC_REGISTER_DETAILS = "NCD_CBAC_Register_Details",

  CHILD_IMMUNIZATION = "Child_Immunization",
  CHILD_IMMUNIZATION_DETAILS = "Child_Immunization_Details",

  // ================= REPORTS =================

  AF_PROFILE_DATA = "AF_Profile_Data",
  ASHA_PROFILE_DATA = "Asha_Profile_Data",

  ASHA_TRAINING_FORM_REPORT = "Asha_Training_Form_Report",

  BF_TRAINING_FORM_REPORT = "BF-Training-Form-Report",

  ASHA_TRAINING_TRANSACTION_REPORT = "Asha-Training-Transaction-Report",
  ASHA_TRAINING_SUMMARY_REPORT = "Asha-Training-Summary-Report",
  ASHA_TRAINING_INFORMATION_REPORT = "Asha-Training-Information-Report",

  AF_TRAINING_TRANSACTION_REPORT = "AF-Training-Transaction-Report",

  CENTRAL_INCENTIVE_REPORT = "Central-Incentive-Report",
  STATE_INCENTIVE_REPORT = "State-Incentive-Report",

  ASHA_PERFORMANCE_REPORT = "Asha-Performance-Report",
  ASHA_INCENTIVE_REPORT = "Asha-Incentive-Report",
  MONTHLY_ASHA_INCENTIVE_REPORT = "Monthly-Asha-Incentive-Report",
  BF_WISE_INCENTIVE_REPORT = "BF-Wise-Incentive-Report",

  MONTHLY_HBNC_REPORT_MAIN = "Monthly-HBNC-Report",
  MONTHLY_HBYC_REPORT_MAIN = "Monthly-HBYC-Report",

  MAA_MEETING_REPORT = "MAA-Meeting-Report",
  MONTHLY_HBYC_UNTRAINED_ASHA_REPORT = "Monthly-HBYC-Untrained-Asha-Report",

  GRIEVANCE_MENTORING_TRANSACTION = "Grievance_Monitoring_Transaction",
  GRIEVANCE_MENTORING_REPORT = "Grievance-Mentoring-Report",

  AF_RAJYASHASAN_MANDHAN_REPORT = "AF-Rajyashasan-Mandhan-Report",
  ASHA_RAJYASHASAN_MANDHAN_REPORT = "Asha-Rajyashasan-Mandhan-Report",

  ASHA_AND_AF_POLICY_REPORT = "Asha-and-AF-Policy-Report",

  DEVELOPMENTAL_DELAY_CHILDREN_REPORT = "Developmental_Delay_Children_Report",
  DEFECTIVE_CHILDREN_REPORT = "Defective_Children_Report",

  IODINE_TESTING_REPORT = "Iodine_Testing_Report",

  RBSK_REPORT = "RBSK_Report",
  CUMULITIVE_RBSK_REPORT = "Cumulitive_RBSK_Report",

  SPACING_OF_BIRTH_REPORT = "Spacing_Of_Birth_Report",

  HR_REPORT = "HR_Report",

  CONTRACEPTIVE_PILL_REPORT = "Contraceptive_Pill_Report",

  HBNC_KIT_REPORT = "HBNC-Kit-Report",

  SANITARY_NAPKIN_REPORT = "Sanitary-Napkin-Report",

  BCM_VISIT_RECORD_REPORT = "BCM-Visit-Record-Report",
  AF_VISIT_RECORD_REPORT = "AF-Visit-Record-Report",

  FEATURE_GROUP = "Feature-Group",

  ASHA_AF_POLICY_REPORT = "Asha_AF_Policy_Report",

  FAMILY_SURVEY_REGISTER = "Family-Survey-Register-Report",
  GRAM_HEALTH_SURVEY_REGISTER = "Gram-Health-Survey-Register-Report",

  ELIGIBLE_COUPLE_HISTORY_REPORT = "Eligible-Couple-History-Report",
  MAATA_REGISTER_REPORT = "Maata-Register-Report",
  NORMAL_MAATA_REGISTER_REPORT = "Normal-Maata-Register-Report",

  BIRTH_REGISTER_REPORT = "Birth-Register-Report",
  INFORMATION_ON_STILL_BIRTH_REPORT = "Information-On-Still-Birth-Report",
  DETAILED_DEATHS_ABOVE_Five_REPORT = "Detailed-Deaths-Above-Five-Report",

  PREMATURE_DEATHS_UNDER_FIVE_REPORT = "Premature-Deaths-Under-Five-Report",

  // Dashboard component
  ASHA_AF_EMPLOYEE_STATE_INCENTIVE_REPORT = "Asha-Af-Employee-State-Incentive-Report",
  DASHBOARD_ANEMIA_MUKTA_BHARAT = "Dashboard_Anemia_Mukta_Bharat",
  DASHBOARD_ASHA_INCENTIVE = "Dashboard_Asha_Incentive",
  DASHBOARD_CONTRACEPTIVE_PILLS = "Dashboard_Contraceptive_pills",

  DASHBOARD_ASHA_CENTRAL_STATE_INCENTIVE = "Dashboard_Asha_Central_State_Incentive",
  DASHBOARD_AF_CENTRAL_STATE_INCENTIVE = "Dashboard_AF_Central_State_Incentive",

  DASHBOARD_TOP_FIVE_ASHA_INCENTIVE = "Dashboard_Top_Five_Asha_Incentive",
  DASHBOARD_TOTAL_AHSA_REGISTERED = "Dashboard_Total_Asha_Registered",
  // Landing Page
  LANDING_PAGE = "Landing_Page",
  PRIVACY_POLICY = "privacy-policy",
  TERMS_AND_CONDITIONS = "terms-conditions",

  // Maata Register
  MAATA_REGISTER = "Maata_Register",
  MAATA_REGISTER_DETAILS = "Maata_Register_Details",

  // birth Register
  BIRTH_REGISTER = "Birth_Register",
  BIRTH_REGISTER_DETAILS = "Birth_Register_Details",
  // Death Register
  DEATH_REGISTER = "Death_Register",
  DEATH_REGISTER_DETAILS = "Death_Register_Details",
}

export const menuMetaConfig: Record<string, { text: string; path: string }> = {
  // Dashboard ──────────────────────────────────────
  Dashboard: { text: "Dashboard", path: "home" },

  // Administrative Master ──────────────────────────
  State: {
    text: "State",
    path: "State_Master",
  },

  Zone: {
    text: "Zone",
    path: "Zone_Master",
  },

  District: {
    text: "District",
    path: "District_Master",
  },

  Block: {
    text: "Block",
    path: "Block_Master",
  },

  PHC: {
    text: "PHC",
    path: "PHC_Master",
  },

  SC: {
    text: "SC",
    path: "SC_Master",
  },

  Village: {
    text: "Village",
    path: "Village_Master",
  },
  Roles: {
    text: "Roles",
    path: "Roles_Master",
  },

  Report_Submission_Configuration: {
    text: "Report Submission Config",
    path: "Report_Configuration_Master",
  },

  // HR Master ──────────────────────────────────────
  Category: {
    text: "Category",
    path: "Category_Master",
  },

  Religion: {
    text: "Religion",
    path: "Religion_Master",
  },

  Vima_Yojana: {
    text: "Vima Yojana",
    path: "Vima_Yojana_Master",
  },
  Relation: {
    text: "Relation",
    path: "Relation_Master",
  },
  DCM_Post: {
    text: "DCM Post",
    path: "Dcm_Post_Master",
  },
  BCM_Post: {
    text: "BCM Post",
    path: "Bcm_Post_Master",
  },
  AF_Post: {
    text: "AF Post",
    path: "Af_Post_Master",
  },
  Asha_Post: {
    text: "Asha Post",
    path: "Asha_Post_Master",
  },
  THO: {
    text: "THO",
    path: "THO_Master",
  },

  DHO: {
    text: "DHO",
    path: "DHO_Master",
  },
  DCM: {
    text: "DCM",
    path: "DCM_Master",
  },
  BCM: {
    text: "BCM",
    path: "BCM_Master",
  },
  MO: {
    text: "MO",
    path: "MO_Master",
  },
  AF: {
    text: "AF",
    path: "AF_Master",
  },
  Asha: {
    text: "Asha",
    path: "Asha_Master",
  },
  Promotion: {
    text: "Promotion",
    path: "Promotion_Master",
  },
  Termination: {
    text: "Termination",
    path: "Termination_Master",
  },
  Resignation: {
    text: "Resignation",
    path: "Resignation_Master",
  },

  AF_Central_Incentive: {
    text: "AF Central Incentive",
    path: "AF_Central_Incentive",
  },

  AF_State_Incentive: {
    text: "AF State Incentive",
    path: "AF_State_Incentive_Master",
  },
  Employee_Visit_Type: {
    text: "Employee Visit Type",
    path: "Visit_Type_Master",
  },
  // Training Master ────────────────────────────────
  Training_Group: {
    text: "Training Group",
    path: "Training_Group_Master",
  },
  Training_Type: {
    text: "Training Type",
    path: "Training_Type_Master",
  },

  // Performance Master ─────────────────────────────
  Performance_Group: {
    text: "Performance Group",
    path: "Performance_Group_Master",
  },
  Performance_Type_Master: {
    text: "Performance Type",
    path: "Performance_Type_Master",
  },
  Performance_Activity_Rate: {
    text: "Activity Rate",
    path: "Activity_Rate_Master",
  },

  // Child Master ───────────────────────────────────
  HBNC_Group: {
    text: "HBNC Group",
    path: "Hbnc_Group_Master",
  },
  HBNC_Type: {
    text: "HBNC Type",
    path: "Hbnc_Type_Master",
  },
  HBNC_Kit: {
    text: "HBNC Kit",
    path: "Hbnc_Kit_Group",
  },
  HBYC_Group: {
    text: "HBYC Group",
    path: "Hbyc_Group_Master",
  },
  HBYC_Type: {
    text: "HBYC Type",
    path: "Hbyc_Type_Master",
  },
  HBYC_Untrained_Group: {
    text: "HBYC Untrained Group",
    path: "Hbyc_Untrained_Group_Master",
  },
  HBYC_Untrained_Type: {
    text: "HBYC Untrained Type",
    path: "Hbyc_Untrained_Type_Master",
  },
  Mother_Meeting_Group: {
    text: "Mother Meeting Group",
    path: "Mother_Meeting_Group_Master",
  },
  Mother_Meeting_Type: {
    text: "Mother Meeting Type",
    path: "Mother_Meeting_Type_Master",
  },
  Spacing_of_Birth_Group: {
    text: "Spacing of Birth Group",
    path: "Spacing_Of_Birth_Group_Master",
  },
  Spacing_of_Birth_Type: {
    text: "Spacing of Birth Type",
    path: "Spacing_Of_Birth_Type_Master",
  },

  // RBSK Master ────────────────────────────────────
  Birth_Defect_Type: {
    text: "Birth Defect Type",
    path: "Birth_Defect_Type_Master",
  },

  // Stock Master ───────────────────────────────────
  Sanitary_Napkin_Rate: {
    text: "Sanitary Napkin Rate",
    path: "Sanitary_Napkin_Rate_Master",
  },

  // Landing Page ─────────────────────────────
  About_Master: {
    text: "About Master",
    path: "About_Master",
  },
  Work_Gallery_Master: {
    text: "Work Gallery Master",
    path: "Work_Gallery_Master",
  },
  Training_Video_Master: {
    text: "Training Video Master",
    path: "Training_Video_Master",
  },
  Health_Department_Profile_Master: {
    text: "Health Department Profile Master",
    path: "Health_Department_Profile_Master",
  },

  // HR Transaction ─────────────────────────────────
  AF_Central_Incentive_Transaction: {
    text: "AF Central Incentive",
    path: "AF_Central_Incentive_Transaction",
  },
  Asha_Hr: {
    text: "Asha HR",
    path: "Asha_Hr_Transaction",
  },

  State_Incentive_Transaction: {
    text: "State Incentive",
    path: "State_Incentive_Transaction",
  },

  Employee_State_Incentive: {
    text: "Employee State Incentive",
    path: "Employee_State_Incentive_Transaction",
  },

  // Training Transaction ───────────────────────────
  Asha_Training: {
    text: "Asha Training",
    path: "Asha_Training_Form",
  },

  Asha_Training_Report: {
    text: "Asha Training Report",
    path: "Asha_Training_Report",
  },
  AF_Training_Report: {
    text: "AF Training Report",
    path: "AF_Training_Report",
  },

  // Performance Transaction ────────────────────────
  Asha_Performance: {
    text: "Asha Performance",
    path: "Asha_Performance_Form",
  },

  // Child Transaction ──────────────────────────────
  // Monthly_HBNC_Master: {
  //   text: "Monthly HBNC",
  //   path: "Monthly_HBNC_Master"
  // },

  Monthly_HBNC_Transaction: {
    text: "Monthly HBNC",
    path: "Monthly_HBNC_Transaction",
  },

  AF_HBNC: {
    text: "AF HBNC",
    path: "Af_HBNC_Transaction",
  },
  Monthly_HBYC_Transaction: {
    text: "Monthly HBYC",
    path: "Monthly_HBYC_Transaction",
  },
  Monthly_HBYC_Untrained: {
    text: "Monthly HBYC Untrained",
    path: "HBYC_Untrained_Asha_Report",
  },
  MAA_Meeting: {
    text: "MAA Meeting",
    path: "MAA_Meeting",
  },
  Developmental_Delay_Children: {
    text: "Developmental Delay Children",
    path: "Developmental_Delay_Children",
  },
  Defective_Children: {
    text: "Defective Children",
    path: "Defective_Children",
  },
  RBSK_Transaction: {
    text: "RBSK",
    path: "RBSK_Transaction",
  },
  Spacing_of_Birth: {
    text: "Spacing of Birth",
    path: "Spacing_of_Birth",
  },
  Iodine_Testing: {
    text: "Iodine Testing",
    path: "Iodine_Testing_Transaction",
  },

  // Stock Transaction ──────────────────────────────
  Contraceptive_Pills_Opening_Stock: {
    text: "Contraceptive Pills Opening Stock",
    path: "Contraceptive_Pills_Opening_Stock_Master",
  },
  Contraceptive_Pill: {
    text: "Contraceptive Pill",
    path: "Trans_Contraceptive_Pill",
  },
  HBNC_Kit_Transaction: {
    text: "HBNC Kit",
    path: "HBNC_Kit_Transaction",
  },
  Sanitary_Napkin_Opening: {
    text: "Sanitary Napkin Opening Stock",
    path: "Sanitary_Napkin_Opening_Stock",
  },
  Sanitary_Napkin_Distribution: {
    text: "Sanitary Napkin Distribution",
    path: "Sanitary_Napkin_Distribution",
  },
  Anemia_Mukta_Bharat_Opening_Stock: {
    text: "Anemia Mukta Bharat Opening Stock",
    path: "Anemia_Mukta_Bharat_Opening_Stock_Master",
  },
  Anemia_Mukta_Bharat_Distribution: {
    text: "Anemia Mukta Bharat",
    path: "Anemia_Mukta_Bharat_Distribution",
  },

  // Other Transaction ──────────────────────────────
  Grievance_Monitoring_Transaction: {
    text: "Grievance Monitoring",
    path: "Grievance_Monitoring_Transaction",
  },
  Employee_Visit_Transaction: {
    text: "Employee Visit",
    path: "Visit_Form",
  },
  Edit_Request: {
    text: "Edit Request",
    path: "Edit_Request_Form",
  },

  Edit_Request_Approval: {
    text: "Edit Request Approval",
    path: "Edit_Request_Approval_Form",
  },

  // Family Registration ──────────────────────────
  Family_Registration: {
    text: "Family Registration",
    path: "Family_Registration",
  },

  // Eligible Couple ──────────────────────────
  Eligible_Couple: {
    text: "Eligible Couple",
    path: "Eligible_Couple",
  },

  // Maata Register  ──────────────────────────
  Maata_Register: {
    text: "ANC",
    path: "Maata_Register",
  },

  //  Birth gister  ──────────────────────────
  Birth_Register: {
    text: "Birth Register",
    path: "Birth_Register",
  },
  // Death Register  ──────────────────────────
  Death_Register: {
    text: "Death Register",
    path: "Death_Register",
  },

    // HBNC Register ──────────────────────────
  HBNC_Register: {
    text: "HBNC Register",
    path: "HBNC_Register",
  },

  // HGBYC Register ──────────────────────────
  HBYC_Register: {
    text: "HBYC Register",
    path: "HBYC_Register",
  },

    // NCD CBAC Register ──────────────────────────
  NCD_CBAC_Register: {
    text: "NCD CBAC Register",
    path: "NCD_CBAC_Register",
  },

     // NCD CBAC Register ──────────────────────────
  Child_Immunization: {
    text: "Child Immunization",
    path: "Child_Immunization",
  },

  // HR Reports ─────────────────────────────────────
  AF_Profile_Data_Report: {
    text: "AF Profile Data",
    path: "AF_Profile_Data",
  },
  Asha_Profile_Data: {
    text: "Asha Profile Data",
    path: "Asha_Profile_Data",
  },
  HR_Report: {
    text: "HR Report",
    path: "HR_Report",
  },
  Asha_Incentive_Report: {
    text: "Asha Incentive Report",
    path: "Asha-Incentive-Report",
  },
  Monthly_Asha_Incentive_Report: {
    text: "Monthly Asha Incentive",
    path: "Monthly-Asha-Incentive-Report",
  },
  AF_Wise_Incentive_Report: {
    text: "AF Wise Incentive",
    path: "BF-Wise-Incentive-Report",
  },
  AF_Rajyashasan_Mandhan_Report: {
    text: "AF Rajyashasan Mandhan",
    path: "AF-Rajyashasan-Mandhan-Report",
  },
  Asha_Rajyashasan_Mandhan_Report: {
    text: "Asha Rajyashasan Mandhan",
    path: "Asha-Rajyashasan-Mandhan-Report",
  },
  Central_Incentive_Report: {
    text: "Central Incentive Report",
    path: "Central-Incentive-Report",
  },
  State_Incentive_Report: {
    text: "State Incentive Report",
    path: "State-Incentive-Report",
  },

  Asha_AF_Policy_Report: {
    text: "Asha AF Policy Report",
    path: "Asha_AF_Policy_Report",
  },

  // Training Reports ───────────────────────────────
  Asha_Training_Form_Report: {
    text: "Asha Training Information",
    path: "Asha-Training-Form-Report",
  },

  Asha_Training_Information_Report: {
    text: "Asha Training Information",
    path: "Asha_Training_Form_Report",
  },

  AF_Training_Information_Report: {
    text: "AF Training Information",
    path: "BF-Training-Form-Report",
  },
  Asha_Training_Summary_Report: {
    text: "Asha Training Summary",
    path: "Asha-Training-Summary-Report",
  },
  AF_Training_Summary_Report: {
    text: "AF Training Summary",
    path: "AF-Training-Transaction-Report",
  },

  // Performance Reports ────────────────────────────
  Asha_Performance_Report: {
    text: "Asha Performance Report",
    path: "Asha-Performance-Report",
  },

  // Child Reports ──────────────────────────────────
  Monthly_HBNC_Report: {
    text: "Monthly HBNC Report",
    path: "Monthly-HBNC-Report",
  },
  Monthly_HBYC_Report: {
    text: "Monthly HBYC Report",
    path: "Monthly-HBYC-Report",
  },
  Monthly_HBYC_Untrained_Report: {
    text: "Monthly HBYC Untrained",
    path: "Monthly-HBYC-Untrained-Asha-Report",
  },
  MAA_Meeting_Report: {
    text: "MAA Meeting Report",
    path: "MAA-Meeting-Report",
  },
  Developmental_Delay_Children_Report: {
    text: "Developmental Delay Report",
    path: "Developmental_Delay_Children_Report",
  },
  Defective_Children_Report: {
    text: "Defective Children Report",
    path: "Defective_Children_Report",
  },
  Cumulitive_RBSK_Report: {
    text: "Cumulative RBSK Report",
    path: "Cumulitive_RBSK_Report",
  },
  RBSK_Report: {
    text: "RBSK Report",
    path: "RBSK_Report",
  },
  Spacing_Of_Birth_Report: {
    text: "Spacing Of Birth Report",
    path: "Spacing_Of_Birth_Report",
  },

  // Stock Reports ──────────────────────────────────
  Contraceptive_Pill_Report: {
    text: "Contraceptive Pill Report",
    path: "Contraceptive_Pill_Report",
  },
  HBNC_Kit_Report: {
    text: "HBNC Kit Report",
    path: "HBNC-Kit-Report",
  },
  Sanitary_Napkin_Report: {
    text: "Sanitary Napkin Report",
    path: "Sanitary-Napkin-Report",
  },

  // Other Reports ──────────────────────────────────
  Iodine_Testing_Report: {
    text: "Iodine Testing Report",
    path: "Iodine_Testing_Report",
  },
  Grievance_Mentoring_Report: {
    text: "Grievance Mentoring Report",
    path: "Grievance-Mentoring-Report",
  },
  AFEmployee_Visit_Record_Report: {
    text: "AF Visit Record Report",
    path: "AF-Visit-Record-Report",
  },
  BCMEmployee_Visit_Record_Report: {
    text: "BCM Visit Record Report",
    path: "BCM-Visit-Record-Report",
  },

  Family_Survey_Register_Report: {
    text: "Family Survey Report",
    path: "Family-Survey-Register-Report",
  },
  Gram_Health_Survey_Register_Report: {
    text: "Gram Health Survey Report",
    path: "Gram-Health-Survey-Register-Report",
  },

  Eligible_Couple_History_Report: {
    text: "Eligible Couple",
    path: "Eligible-Couple-History-Report",
  },

  Maata_Register_Report: {
    text: "High-Risk Maata Register",
    path: "Maata-Register-Report",
  },

  Normal_Maata_Register_Report: {
    text: "Normal Maata Register",
    path: "Normal-Maata-Register-Report",
  },

  Birth_Register_Report: {
    text: "Birth Register Report",
    path: "Birth-Register-Report",
  },

 Information_On_Still_Birth_Report: {
    text: "Information on Still-Birth",
    path: "Information-On-Still-Birth-Report",
  },

  Detailed_Deaths_Above_Five_Report: {
    text: "Detailed Death Above Five",
    path: "Detailed-Deaths-Above-Five-Report",
  },

   Premature_Deaths_Under_Five_Report: {
    text: "Premature Death Under Five",
    path: "Premature-Deaths-Under-Five-Report",
  },

  // Dashboard drill-down components ─────────────────
  Asha_Af_Employee_State_Incentive_Report: {
    text: "Asha AF State Incentive",
    path: "Asha-Af-Employee-State-Incentive-Report",
  },
  Dashboard_Anemia_Mukta_Bharat: {
    text: "Anemia Mukta Bharat Stock",
    path: "Dashboard_Anemia_Mukta_Bharat",
  },
  Dashboard_Asha_Incentive: {
    text: "Asha Incentive",
    path: "Dashboard_Asha_Incentive",
  },
  Dashboard_Contraceptive_Pills: {
    text: "Contraceptive Pills Stock",
    path: "Dashboard_Contraceptive_pills",
  },
};
